import { getWishlist } from "@repo/server-actions/wishlist";
import { Link } from "@/i18n/routing";
import { IconWishlist } from "@repo/assets/images";
const WishlistIcon = async ({
  locale,
  session
}) => {
  const wishlist = await getWishlist(locale);
  const itemsQuantity = wishlist?.content?.length || 0;
  const goToWishlist = session ? "/account/favourites" : "/favourites";
  return <Link href={goToWishlist} className="relative block" data-sentry-element="Link" data-sentry-component="WishlistIcon" data-sentry-source-file="WishlistIcon.jsx">
      <IconWishlist className="text-header-icon h-5 w-7 fill-current md:h-7" data-sentry-element="IconWishlist" data-sentry-source-file="WishlistIcon.jsx" />
      {itemsQuantity > 0 && <div className="absolute -end-2.5 -top-2 size-[20px] rounded-full bg-red-600">
          <div className="flex h-full items-center justify-center text-[11px] font-bold text-white">
            {itemsQuantity}
          </div>
        </div>}
    </Link>;
};
export default WishlistIcon;